import React, { Fragment, useEffect, useState } from "react"
import { Box } from "@rebass/grid/emotion"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"

import { INGREDIENTS_IMAGES_NOVA } from "../../../../utils/imagesMap"

import {
  ButtonContainer,
  IngredientsContainer,
  DisclaimerBox,
} from "./ingredients.styled"
import { TimedButton } from "./timedbutton"

const Core = {
  INTERVAL_TIME: 5000,
  sectionHeading:
    "The award-winning hair growth formula <br class='max-sm:hidden' />with <span class='font-grilliItalic'>patented Synergen Complex&reg;.</span>",
  buttonNames: [
    "Sensoril&reg; Ashwagandha",
    "Tocotrienol Complex",
    "Marine Collagen Peptides",
    "Saw Palmetto",
    "Curcumin",
  ],
  images: [
    "https://images.ctfassets.net/0rbfqd9c4jdo/4fPqRSds0uve2nbg39msiG/f51437279366ce38ac49036a0071a8c6/sensoril-ashwagandha_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/4Bhda9ptFOBCg9TTiYZdBN/d992e18707cc42266f91db185f0c1c93/tocotrienol-complex_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/2aiEhOGqtEZgpDuAh7scmG/3e11ea23dd244ff862a92dc5af878106/marine-collagen-peptides_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/3F1eO7GCXWebAoZLLkTr9S/97e006f155d61296f6e1cb04d420581f/saw-palmetto_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/1xBaXEJQzZXDRvJbsp9Ylh/aa1171c741c49cc176e87f4088f92d68/curcumin_1-1.jpg?fl=progressive",
  ],
  disclaimers: [
    "A botanical shown to lower cortisol levels for stress relieving benefits to reduce hair shedding.",
    "A concentrated form of vitamin E, an antioxidant that fights against environmental stress to improve hair density.",
    "Peptides that provide the building blocks of strong hair fibers, while delivering hydration to the scalp.",
    "Provides concentrated fatty acids, clinically shown to reduce the conversion of testosterone to DHT to improve hair growth.",
    "Extracted from turmeric for its antioxidant properties that fight free radicals to support cellular health.",
  ],
  modalButton: {
    label: "See Full Ingredients List",
    destination: "/ingredients/",
    isTextLink: true,
    module_location: "mid_fold",
  },
}

const Balance = {
  INTERVAL_TIME: 5000,
  sectionHeading:
    "The award-winning hair growth formula <br class='max-sm:hidden' />with <span class='font-grilliItalic'>patented Synergen Complex Plus&reg;.</span>",
  buttonNames: [
    "Sensoril&reg; Ashwagandha",
    "Maca",
    "Saw Palmetto",
    "Astaxanthin",
    "Marine Collagen Peptides",
    "Curcumin",
    "Tocotrienol Complex",
  ],
  images: [
    "https://images.ctfassets.net/0rbfqd9c4jdo/4fPqRSds0uve2nbg39msiG/f51437279366ce38ac49036a0071a8c6/sensoril-ashwagandha_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/4k9pRZICZyawJHS0bs1gNJ/5b0a54427dccf37616efddd3b321366f/maca_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/3F1eO7GCXWebAoZLLkTr9S/97e006f155d61296f6e1cb04d420581f/saw-palmetto_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/4NpTIupw2YtKTpecelWst/75e1c945b9f838d6c06ead77dd81b67a/astaxanthin_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/2aiEhOGqtEZgpDuAh7scmG/3e11ea23dd244ff862a92dc5af878106/marine-collagen-peptides_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/1xBaXEJQzZXDRvJbsp9Ylh/aa1171c741c49cc176e87f4088f92d68/curcumin_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/4Bhda9ptFOBCg9TTiYZdBN/d992e18707cc42266f91db185f0c1c93/tocotrienol-complex_1-1.jpg?fl=progressive",
  ],
  disclaimers: [
    "A botanical shown to lower cortisol levels for stress relieving benefits to reduce hair shedding.",
    "An organic root that eases the hormonal transition that triggers hair thinning during menopause.",
    "Provides concentrated fatty acids, clinically shown to reduce the conversion of testosterone to DHT to improve hair growth.",
    "Provides antioxidant activity that helps lower signs of aging by energizing the cells needed to grow hair.",
    "Peptides that provide the building blocks of strong hair fibers, while delivering hydration to the scalp.",
    "Extracted from turmeric for its antioxidant properties that fight free radicals to support cellular health.",
    "A concentrated form of vitamin E, an antioxidant that fights against environmental stress to improve hair density.",
  ],
  modalButton: {
    label: "See Full Ingredients List",
    destination: "/ingredients/",
    isTextLink: true,
    module_location: "mid_fold",
  },
}

const Vegan = {
  INTERVAL_TIME: 5000,
  sectionHeading:
    "100% vegan hair growth formula with our patented <br class='max-sm:hidden' />Synergen Plant Complex.",
  buttonNames: [
    "Sensoril&reg; Ashwagandha",
    "Tocotrienol Complex",
    "Moldavian Dragonhead",
    "Saw Palmetto",
    "Curcumin",
  ],
  images: [
    "https://images.ctfassets.net/0rbfqd9c4jdo/4fPqRSds0uve2nbg39msiG/f51437279366ce38ac49036a0071a8c6/sensoril-ashwagandha_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/4Bhda9ptFOBCg9TTiYZdBN/d992e18707cc42266f91db185f0c1c93/tocotrienol-complex_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/uE5jnxi7YXeHodzRr5DJK/e1b9d53e1dc3006493499f2b8ef1189e/moldavian-dragonhead_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/3F1eO7GCXWebAoZLLkTr9S/97e006f155d61296f6e1cb04d420581f/saw-palmetto_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/1xBaXEJQzZXDRvJbsp9Ylh/aa1171c741c49cc176e87f4088f92d68/curcumin_1-1.jpg?fl=progressive",
  ],
  disclaimers: [
    "A botanical shown to lower cortisol levels for stress relieving benefits to reduce hair shedding.",
    "A concentrated form of vitamin E, an antioxidant that fights against environmental stress to improve hair density.",
    "A plant extract clinically shown to promote natural collagen production in the body.",
    "Provides concentrated fatty acids, clinically shown to reduce the conversion of testosterone to DHT to improve hair growth.",
    "Extracted from turmeric for its antioxidant properties that fight free radicals to support cellular health.",
  ],
  modalButton: {
    label: "See Full Ingredients List",
    destination: "/ingredients/",
    isTextLink: true,
    module_location: "mid_fold",
  },
}

const Postpartum = {
  INTERVAL_TIME: 5000,
  sectionHeading:
    "Postpartum replenishment with <br class='max-sm:hidden md:hidden' />100% drug-free <br class='max-lg:hidden' />ingredients and our <br class='max-sm:hidden md:hidden' />Synergen Recovery Complex&trade;.",
  buttonNames: [
    "Shatavari",
    "DHA Omega-3s",
    "Apple Polyphenols",
    "Tocotrienol Complex",
    "Stinging Nettle",
    "Collagen-OSA",
    "Theanine",
  ],
  images: [
    "https://images.ctfassets.net/0rbfqd9c4jdo/2YXSDFWfqbIy3xZylJKdT2/cdf8cd3d4fb889034ad861e0ce0ef140/shatavari_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/5u1X5c2f55faAyN3g59bNl/064c19e2cf73c0af3aef6f5f2442c670/dha-omega-3s_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/7bDMyQBgf4j3hbWmQsLOGS/73b13b142462c27909467badd90075a1/apple-polyphenols_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/4Bhda9ptFOBCg9TTiYZdBN/d992e18707cc42266f91db185f0c1c93/tocotrienol-complex_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/66EsuHKqVR4Bq6y9vgzaT0/dfe916e456d25ac01029b2dcbb3d337e/stinging-nettle_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/4ayu7jzqegU2AMFAjCy7Yu/c49cf33b6ca3e95926cce59acb2f3f11/collagen-osa_1-1.jpg?fl=progressive",
    "https://images.ctfassets.net/0rbfqd9c4jdo/6eYO2C2Q4f09CgyxLHzowM/8cbaccc0c1e9fef9d624716f3fc35d87/theanine_1-1.jpg?fl=progressive",
  ],
  disclaimers: [
    "An ancient adaptogen for postpartum women to reduce physical and emotional stress and balance the body and hair growth cycle.",
    "A bioavailable form of fatty acids from algae to help recover from physical stress and support hair health.",
    "A concentrated extract from apple skins shown to improve hair growth by supporting cellular health.",
    "A concentrated form of vitamin E, an antioxidant that fights against environmental stress to improve hair density.",
    "A plant that contains minerals and restores nutrients while being compatible with your body and enhancing other ingredients for better efficacy.",
    "A bio-optimized source of Orthosilicic Acid, a mineral that supports hair thickness, providing nutrition to the hair shaft for strength.",
    "An amino acid that supports the stress response and promotes relaxation.",
  ],
  modalButton: {
    label: "See Full Ingredients List",
    destination: "/ingredients/",
    isTextLink: true,
    module_location: "mid_fold",
  },
}

const HairSerum = {
  INTERVAL_TIME: 5000,
  sectionHeading:
    "Powered by revolutionary, <br /><span class='font-grilliItalic'>fast-absorbing technology.</span>",
  buttonNames: [
    "Ashwagandha Exosomes",
    "Irish Moss Peptides",
    "Sea Buckthorn",
    "Pea Sprouts",
    "Maca",
  ],
  images: [
    INGREDIENTS_IMAGES_NOVA.SENSORIL_ASHWAGANDA.label0,
    INGREDIENTS_IMAGES_NOVA.TOCOTRIENOL_COMPLEX.label0,
    INGREDIENTS_IMAGES_NOVA.MOLDAVIAN_DRAGONHEAD.label0,
    INGREDIENTS_IMAGES_NOVA.SAW_PALMETTO.label0,
    INGREDIENTS_IMAGES_NOVA.CURCUMIN.label0,
  ],
  disclaimers: [
    "Filled with protein, RNA, and lipids, these plant exosomes come from inside the Ashwagandha seed and boost cell renewal.",
    "Algae extract that is overwintered to enhance bioavailability of peptides that supports the growth of visibly thicker, stronger hair.",
    "These plants are rich sources of fatty acids and nutrients that deliver long-lasting hydration to the skin for nourished, healthy-looking hair.",
    "An immature pea extract known to promote visible thickness.",
    "An adaptogen for women that fortifies and strengthens hair when applied to the scalp.",
  ],
  modalButton: {
    label: "See Full Ingredients List",
    destination: "/ingredients/",
    isTextLink: true,
    module_location: "mid_fold",
  },
}

const Shampoo = {
  INTERVAL_TIME: 5000,
  sectionHeading:
    "Get a deep cleanse with ingredients that <br class='hidden sm:block md:hidden'/><span class='font-grilliItalic'>won’t strip your scalp.</span>",
  buttonNames: [
    "Alpha-glucan oligosaccharide",
    "Australian Wild Berries",
    "Vegan Proteins",
    "Biosurfactant",
  ],
  images: [
    INGREDIENTS_IMAGES_NOVA.ALPHA_GLUCAN_OLIGOSACCHARIDE.label0,
    INGREDIENTS_IMAGES_NOVA.AUSTRALIAN_WILD_BERRIES.label0,
    INGREDIENTS_IMAGES_NOVA.VEGAN_PROTEINS.label0,
    INGREDIENTS_IMAGES_NOVA.BIOSURFACTANT.label0,
  ],
  disclaimers: [
    "A prebiotic that helps strengthen the scalp barrier by feeding the microbiome.",
    "Antioxidants for healthier-looking hair and a hydrated scalp during exfoliation.",
    "Energizes the scalp by providing nourishment and moisture to hair while gently cleansing.",
    "Bio-based cleanser that improves the microbiome without stripping natural oils.",
  ],
  modalButton: {
    label: "See Full Ingredients List",
    destination: "/ingredients/",
    isTextLink: true,
    module_location: "mid_fold",
  },
}

const Conditioner = {
  INTERVAL_TIME: 5000,
  sectionHeading:
    "Protect strands with ingredients that <br class='hidden sm:block md:hidden'/><span class='font-grilliItalic'>won’t weigh your hair down.</span>",
  buttonNames: [
    "Ximenia Oil",
    "Sea Buckthorn",
    "Postbiotics & Arginine",
    "Glucose Fibers",
    "Vegan Proteins",
  ],
  images: [
    `${INGREDIENTS_IMAGES_NOVA.XIMENIA_OIL.label0}`,
    `${INGREDIENTS_IMAGES_NOVA.SEA_BUCKTHORN.label0}`,
    `${INGREDIENTS_IMAGES_NOVA.POSTBIOTIC_ARGININE.label0}`,
    `${INGREDIENTS_IMAGES_NOVA.GLUCOSE_FIBERS.label0}`,
    `${INGREDIENTS_IMAGES_NOVA.VEGAN_PROTEINS.label0}`,
  ],
  disclaimers: [
    "Provides intense moisturization without silicones to soothe damage-prone hair.",
    "Rich in vitamins and fatty acids, locks in moisture, improves elasticity, and protects the hair cuticle.",
    "Fermented amino acids that support weakened bonds and minimize the appearance of hair damage while protecting against future damage.",
    "Strengthen hair from the inside out, making hair more manageable over time and helping to reduce future breakage.",
    "Peptides and wheat proteins that utilize different-sized molecules to strengthen hair strands.",
  ],
  modalButton: {
    label: "See Full Ingredients List",
    destination: "/ingredients/",
    isTextLink: true,
    module_location: "mid_fold",
  },
}

const Ingredients = ({ data, onCtaClick, hideCta = false }) => {
  let content
  if (data.name === "Nutrafol Women") {
    content = Core
  } else if (data.name === "Nutrafol Women's Balance") {
    content = Balance
  } else if (data.name === "Nutrafol Women`s Vegan") {
    content = Vegan
  } else if (data.name === "Nutrafol Postpartum") {
    content = Postpartum
  } else if (data.name === "Hair Serum") {
    content = HairSerum
  } else if (data.name === "Shampoo") {
    content = Shampoo
  } else if (data.name === "Conditioner") {
    content = Conditioner
  } else {
    content = data
  }

  const [activeButtonIndex, setActiveButtonIndex] = useState(0)
  const [timerId, setTimerId] = useState(null)
  const [isPaused, setIsPaused] = useState(false)

  const activeDisclaimer = data.disclaimers
    ? data.disclaimers[activeButtonIndex]
    : content.disclaimers[activeButtonIndex]
  const activeImage = data.images
    ? data.images[activeButtonIndex]
    : content.images[activeButtonIndex]

  const startCycle = () => {
    if (!isPaused) {
      const id = setInterval(() => {
        if (data.buttonNames) {
          setActiveButtonIndex(
            (prevIndex) => (prevIndex + 1) % data.buttonNames.length
          )
        } else {
          setActiveButtonIndex(
            (prevIndex) => (prevIndex + 1) % content.buttonNames.length
          )
        }
      }, content.INTERVAL_TIME)
      setTimerId(id)
    }
  }

  const stopCycle = () => {
    if (timerId) clearInterval(timerId)
  }

  const handleButtonClick = (index) => {
    stopCycle()
    setIsPaused(true)
    setActiveButtonIndex(index)

    const eventObj = {
      module_location: "mid_fold",
      module_name: data.sectionHeading ? data.sectionHeading : null,
      type: "button",
      text: data.buttonNames[index]
        ? data.buttonNames[index]
        : content.buttonNames[index],
    }
    segmentEvent("Module Tab Clicked", eventObj)
  }

  const handleModalButtonClick = (button) => {
    if (onCtaClick) {
      onCtaClick()
      segmentEvent("Modal Viewed", {
        name: content.modalButton?.label,
      })
    } else {
      if (button.destination.indexOf("https") > -1) {
        if (button.destination.indexOf("nutrafol.com") > -1) {
          window.location = button.destination
        } else {
          window.open(button.destination, "_blank")
        }
      } else {
        window.location = button.destination
      }
    }
  }

  useEffect(() => {
    startCycle()
    return () => stopCycle()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPaused])

  return (
    <IngredientsContainer>
      <Box maxWidth={data?.headingMaxWidths || null} mx={"auto"}>
        <TextElementNova
          text={data?.sectionHeading || content.sectionHeading}
          className="text-nova-base-white Title-20-Super-Normal text-center heading"
          element="h2"
        />
      </Box>

      <ButtonContainer className="button-container mobile">
        {data.buttonNames
          ? data.buttonNames.map((button, index) => (
              <React.Fragment key={button}>
                <TimedButton
                  button={button}
                  index={index}
                  activeButtonIndex={activeButtonIndex}
                  isPaused={isPaused}
                  onClick={() => handleButtonClick(index)}
                />
              </React.Fragment>
            ))
          : content.buttonNames.map((button, index) => (
              <React.Fragment key={button}>
                <TimedButton
                  button={button}
                  index={index}
                  activeButtonIndex={activeButtonIndex}
                  isPaused={isPaused}
                  onClick={() => handleButtonClick(index)}
                />
              </React.Fragment>
            ))}
      </ButtonContainer>

      <div className="inner-container">
        <div className="left-column">
          <ButtonContainer className="button-container desktop">
            {data.buttonNames
              ? data.buttonNames.map((button, index) => (
                  <Fragment key={button}>
                    <TimedButton
                      button={button}
                      index={index}
                      activeButtonIndex={activeButtonIndex}
                      isPaused={isPaused}
                      onClick={() => handleButtonClick(index)}
                    />
                  </Fragment>
                ))
              : content.buttonNames.map((button, index) => (
                  <Fragment key={button}>
                    <TimedButton
                      button={button}
                      index={index}
                      activeButtonIndex={activeButtonIndex}
                      isPaused={isPaused}
                      onClick={() => handleButtonClick(index)}
                    />
                  </Fragment>
                ))}
          </ButtonContainer>

          <div className="mobile-image-box relative">
            <img src={activeImage} className="h-full object-cover" alt="" />
          </div>

          <DisclaimerBox>
            <TextElementNova
              className="text-nova-base-white"
              text={activeDisclaimer}
              classes={{
                default: "Body-20-Dia-Normal",
                1024: "Body-30-Dia-Normal",
              }}
            />
          </DisclaimerBox>

          <Box className="md:pb-lg"></Box>
        </div>

        <Box width={[1, 1, "50%", "50%", "50%"]} className="desktop-image-box">
          <div className="relative h-full">
            <img src={activeImage} className="h-full object-cover" alt="" />
          </div>
        </Box>
      </div>

      {!hideCta ? (
        <ButtonNova
          icon="Left"
          level="Tertiary"
          className="modal-button"
          label={content.modalButton?.label}
          onClick={() => {
            handleModalButtonClick(content.modalButton)
          }}
        />
      ) : null}
    </IngredientsContainer>
  )
}

export default Ingredients
